import { useState } from 'react';
import { createPortal } from 'react-dom';
import { MessageCircle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AskAiModal from './AskAiModal';

const AskAiButton = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    return createPortal(
        <>
            <button
                onClick={() => setIsOpen(!isOpen)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className="fixed bottom-14 right-6 flex items-center justify-center w-14 h-14 rounded-full transition-all duration-200"
                style={{
                    zIndex: 1000000,
                    backgroundColor: '#2F4E70',
                    color: 'var(--primary-color, #ffffff)',
                    transform: isHovered ? 'scale(1.08)' : 'scale(1)',
                    boxShadow: isHovered
                        ? '0 12px 28px rgba(0,0,0,0.28)'
                        : '0 8px 24px rgba(0,0,0,0.2)',
                }}
                aria-label={isOpen ? t('ask_ai_close_assistant') : t('ask_ai_open')}
            >
                {isOpen ? <X size={28} /> : <MessageCircle size={28} />}
            </button>

            <AskAiModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            />
        </>,
        document.body
    );
};

export default AskAiButton;
